module.exports = __webpack_public_path__ + "fonts/Poppins-Bold.a3e0b5f.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Poppins/Poppins-Bold.ttf
// module id = 154
// module chunks = 245 246